import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logoutFetch } from "../../../store/authSlice";
import { getLoginPath } from "../../../utils/authRedirect";
import { IconBell, IconSettings } from "../../ui/icons";
import GlobalPatientSearch from "../GlobalPatientSearch";
import DesktopSidebar, { desktopSidebarStyles as ds } from "./DesktopSidebar";
import md from "./manageDesktop.module.css";
import {
  adminFirstName,
  adminGreeting,
  adminTodayLabel,
} from "../AdminPortal/adminAppUtils";
import L from "../../../constants/baysportLabels";
import { normalizeRole } from "../../../utils/roles";

const ROLE_LABEL = {
  owner: "Владелец",
  admin: "Администратор",
  trainer: L.trainer,
};

export default function ManageDesktopShell({
  children,
  homeTo,
  brandRole,
  sections,
  chatBadge = 0,
  notifyBadge = 0,
  notifyOpen,
  onNotifyToggle,
  notifyBtnRef,
  settingsTo,
  profileTo,
  pageTitle,
  isOverview,
  isSchedule,
  isJournal,
  flushContent,
  getBadge,
  shellStyle,
  showSearch = true,
}) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { tenant, profile, role } = useSelector((state) => state.auth);
  const r = normalizeRole(role);
  const firstName = adminFirstName(profile?.full_name);

  const logout = () => {
    dispatch(logoutFetch());
    navigate(getLoginPath(role));
  };

  const badgeFn =
    getBadge ||
    ((item) => (item.id === "chat" ? chatBadge : 0));

  const headerActions = (
    <>
      {showSearch ? (
        <div className={`${ds.topBarSearch} ${md.topBarSearch}`}>
          <GlobalPatientSearch />
        </div>
      ) : null}
      <button
        ref={notifyBtnRef}
        type="button"
        className={ds.iconBtn}
        title="Уведомления"
        aria-label="Уведомления"
        aria-expanded={notifyOpen}
        onClick={onNotifyToggle}
      >
        <IconBell width={17} height={17} />
        {notifyBadge > 0 ? (
          <span className={ds.navBadge}>{notifyBadge > 9 ? "9+" : notifyBadge}</span>
        ) : null}
      </button>
      {settingsTo ? (
        <Link to={settingsTo} className={ds.iconBtn} title="Настройки">
          <IconSettings width={17} height={17} />
        </Link>
      ) : null}
    </>
  );

  const showPageHead = isOverview || Boolean(pageTitle);
  const fullHeightContent = isSchedule || isJournal;

  return (
    <div className={ds.desktopRoot} style={shellStyle}>
      <DesktopSidebar
        homeTo={homeTo}
        brandName={tenant?.name || L.club}
        brandRole={brandRole || ROLE_LABEL[r]}
        sections={sections}
        profile={profile}
        profileTo={profileTo}
        onLogout={logout}
        getBadge={badgeFn}
        headerActions={headerActions}
      />

      <main className={ds.main}>
        {showPageHead ? (
          <div className={ds.pageHead}>
            <div className={ds.pageHeadRow}>
              <div>
                {isOverview ? (
                  <>
                    <h1 className={ds.topBarTitle}>
                      {adminGreeting()}
                      {firstName ? `, ${firstName}` : ""}
                    </h1>
                    <p className={ds.topBarMeta}>{adminTodayLabel()}</p>
                  </>
                ) : (
                  <h1 className={ds.topBarTitle}>{pageTitle}</h1>
                )}
              </div>
            </div>
          </div>
        ) : null}

        <div
          className={fullHeightContent ? ds.contentSchedule : ds.mainScroll}
          data-pull-scroll={!fullHeightContent ? true : undefined}
        >
          <div className={flushContent || fullHeightContent ? ds.contentFlush : ds.content}>
            <div className={flushContent || fullHeightContent ? md.innerWide : md.inner}>
              {children}
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
